import { SHOW_LINKED_CLIENTS_KEY } from "../../../utility/dialogs/constant"

export const isShowLinkedClients = () => !(window.localStorage.getItem(SHOW_LINKED_CLIENTS_KEY) === "false")
